import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translations with namespaces for all 11 languages
import enCommon from './locales/en/common.json';
import enFaq from './locales/en/faq.json';
import enBlogPosts from './locales/en/blogPosts.json';
import enLegal from './locales/en/legal.json';
import frCommon from './locales/fr/common.json';
import frFaq from './locales/fr/faq.json';
import frBlogPosts from './locales/fr/blogPosts.json';
import frLegal from './locales/fr/legal.json';
import esCommon from './locales/es/common.json';
import esFaq from './locales/es/faq.json';
import esBlogPosts from './locales/es/blogPosts.json';
import esLegal from './locales/es/legal.json';
import deCommon from './locales/de/common.json';
import deFaq from './locales/de/faq.json';
import deBlogPosts from './locales/de/blogPosts.json';
import deLegal from './locales/de/legal.json';
import itCommon from './locales/it/common.json';
import itFaq from './locales/it/faq.json';
import itBlogPosts from './locales/it/blogPosts.json';
import itLegal from './locales/it/legal.json';
import ptCommon from './locales/pt/common.json';
import ptFaq from './locales/pt/faq.json';
import ptBlogPosts from './locales/pt/blogPosts.json';
import ptLegal from './locales/pt/legal.json';
import ruCommon from './locales/ru/common.json';
import ruFaq from './locales/ru/faq.json';
import ruBlogPosts from './locales/ru/blogPosts.json';
import ruLegal from './locales/ru/legal.json';
import zhCommon from './locales/zh/common.json';
import zhFaq from './locales/zh/faq.json';
import zhBlogPosts from './locales/zh/blogPosts.json';
import zhLegal from './locales/zh/legal.json';
import arCommon from './locales/ar/common.json';
import arFaq from './locales/ar/faq.json';
import arBlogPosts from './locales/ar/blogPosts.json';
import arLegal from './locales/ar/legal.json';
import hiCommon from './locales/hi/common.json';
import hiFaq from './locales/hi/faq.json';
import hiBlogPosts from './locales/hi/blogPosts.json';
import hiLegal from './locales/hi/legal.json';
import jaCommon from './locales/ja/common.json';
import jaFaq from './locales/ja/faq.json';
import jaBlogPosts from './locales/ja/blogPosts.json';
import jaLegal from './locales/ja/legal.json';

const resources = {
  en: {
    common: enCommon,
    faq: enFaq,
    blogPosts: enBlogPosts,
    legal: enLegal
  },
  fr: {
    common: frCommon,
    faq: frFaq,
    blogPosts: frBlogPosts,
    legal: frLegal
  },
  es: {
    common: esCommon,
    faq: esFaq,
    blogPosts: esBlogPosts,
    legal: esLegal
  },
  de: {
    common: deCommon,
    faq: deFaq,
    blogPosts: deBlogPosts,
    legal: deLegal
  },
  it: {
    common: itCommon,
    faq: itFaq,
    blogPosts: itBlogPosts,
    legal: itLegal
  },
  pt: {
    common: ptCommon,
    faq: ptFaq,
    blogPosts: ptBlogPosts,
    legal: ptLegal
  },
  ru: {
    common: ruCommon,
    faq: ruFaq,
    blogPosts: ruBlogPosts,
    legal: ruLegal
  },
  zh: {
    common: zhCommon,
    faq: zhFaq,
    blogPosts: zhBlogPosts,
    legal: zhLegal
  },
  ar: {
    common: arCommon,
    faq: arFaq,
    blogPosts: arBlogPosts,
    legal: arLegal
  },
  hi: {
    common: hiCommon,
    faq: hiFaq,
    blogPosts: hiBlogPosts,
    legal: hiLegal
  },
  ja: {
    common: jaCommon,
    faq: jaFaq,
    blogPosts: jaBlogPosts,
    legal: jaLegal
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: ['en', 'fr', 'es', 'de', 'it', 'pt', 'ru', 'zh', 'ar', 'hi', 'ja'],
    defaultNS: 'common',
    fallbackNS: 'common',
    interpolation: {
      escapeValue: false // React already escapes
    },
    // Language detection configuration
    detection: {
      order: ['navigator', 'localStorage', 'cookie', 'htmlTag'],
      caches: ['localStorage', 'cookie'],
      lookupCookie: 'i18nextLng',
      lookupLocalStorage: 'i18nextLng',
      cookieMinutes: 10080, // 7 days
      // English (US) as default if no detection
      fallbackLng: 'en'
    },
    // Return key if missing instead of empty string
    returnEmptyString: false,
    returnNull: false,
    saveMissing: false
  });

export default i18n;
